import React, { createContext, useContext, useState, useCallback } from 'react';

const HistoryContext = createContext(null);

export function HistoryProvider({ children, onChange }) {
  const [past, setPast] = useState([]);
  const [future, setFuture] = useState([]);

  const pushState = useCallback((nextState) => {
    setPast((prev) => {
      // Clean duplicate states
      if (prev.length > 0 && JSON.stringify(prev[prev.length - 1]) === JSON.stringify(nextState)) {
        return prev;
      }
      const updated = [...prev, nextState];
      if (updated.length > 50) {
        updated.shift();
      }
      return updated;
    });
    setFuture([]);
  }, []);

  const undo = useCallback((currentState) => {
    if (past.length === 0) return currentState;
    const previous = past[past.length - 1];
    setPast((prev) => prev.slice(0, -1));
    setFuture((prev) => [currentState, ...prev]);
    if (onChange) onChange(previous);
    return previous;
  }, [past, onChange]);

  const redo = useCallback((currentState) => {
    if (future.length === 0) return currentState;
    const next = future[0];
    setFuture((prev) => prev.slice(1));
    setPast((prev) => [...prev, currentState]);
    if (onChange) onChange(next);
    return next;
  }, [future, onChange]);

  const clearHistory = useCallback(() => {
    setPast([]);
    setFuture([]);
  }, []);

  const value = {
    past,
    future,
    pushState,
    undo,
    redo,
    clearHistory,
    canUndo: past.length > 0,
    canRedo: future.length > 0,
  };

  return (
    <HistoryContext.Provider value={value}>
      {children}
    </HistoryContext.Provider>
  );
}

export const useHistory = () => {
  const ctx = useContext(HistoryContext);
  if (!ctx) throw new Error('useHistory must be used within a HistoryProvider');
  return ctx;
};
